import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getMedicoAll } from "../../services/medico";
import IconM from "../dashboard/menu/icons/Icon";
import MedicoModal from "./medicomodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";

function MedicoView() {
  const [tbMedico, setMedicos] = useState([]);
  const { setShowToast, setOpciones } = ErrorContext();
  
 // const { setRuta } = BreadContext();
  const [AreaId, setAreaId] = useState(0);
  const [UsuarioId, setUsuarioId] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [AreaFId, setAreaFId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(tbMedico, page, 10);  
  
  
//------ Metodo para mostrar las areas en la grilla --------------------------------------------------------------------
  const fillMedicos = async () => 
    {
       setShowToast(false);
       const response = await getMedicoAll();
       if (response)
        {
           if (response.status === 200) 
            {
               setMedicos(response.data.data);
               //setArea(response.data.area);
        
             //  if (tag === "2") Deseleccionarfilas(); // si elimina quita lo seleccionado
            } 
           else 
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
    };

//-------- Boton Crear - Editar - Eliminar ----------------------------------------------------------------------------- 
  const handleCrearMedico = (tagId) => 
    {
         if ((selectedRow === null) && (tagId !== 0)) return
         if (tagId === 0) 
         {
           setUsuarioId(0);
           setAreaId(AreaFId);
         }
          
         setShowM(true);
         setTag(tagId);
    };
   
//-------- al dar click en la fila -------------------------------------------------------------------------------------
  const handlefilas = (Item, index) => 
    {
         setSelectedRow(index);
         setUsuarioId(Item.MedicoId);
         setAreaId(Item.AreaId);
    };

//----------------------------------------------------------------------------------------------------------------------
const handleMedicoGuardado = (servicioGuardado) => {
  
  setMedicos((prev) => {
    if (tag === 2) {
      return prev.filter(
        (s) =>
          !(
            s.AreaId === AreaId &&
            s.MedicoId === UsuarioId
          )
      );
    }
    else
    {
 
    // Busca si ya existe la combinación AreaId + ServicioId
    const existe = prev.some(
      (s) =>
        s.AreaId === servicioGuardado.AreaId &&
        s.MedicoId === servicioGuardado.MedicoId
    );

    if (existe) {
      // Actualiza únicamente el registro que tenga ambas llaves
      return prev.map((s) =>
        s.AreaId === servicioGuardado.AreaId &&
        s.Id === servicioGuardado.MedicoId
          ? servicioGuardado
          : s
      );
    }

    // Si no existe esa combinación, agrega el nuevo servicio
    return [...prev, servicioGuardado];
    }
  });
 
};

//----------------------------------------------------------------------------------------------------------------------  
 useEffect(() => 
  {
    setShowM(false);
    fillMedicos();
  }, []);

  return (
    <>
      <div className="">
        <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Medicos</label>
        </div>
      
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearMedico(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>

            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearMedico(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>
  
          </div>
          <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="w-full table-auto">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Identificación</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre Profesional</th>
                   <th className="px-2.5 py-2 text-start font-medium">Especialidad</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.MedicoId}`} onClick={() => handlefilas(item, index)}>
                         <td>
                           <div className="flex items-center gap-3 text-sm text-current">
                             {item.MedicoId}
                           </div>
                         </td>
                         <td>{item.NumeroNit}</td>
                         <td>{item.NombreUsr}</td>
                         <td>{item.NombreEsp}</td>
                         <td>{item.NombreArea}</td>
                       </tr>
                  )})}
                 
               </tbody>
             </table>
             </div>
             <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
       </div>
      {showM &&(
      <MedicoModal
        show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        UsuarioI={UsuarioId}
        Tag={tag}
        handleshow={setShowM}
        onGuardado={handleMedicoGuardado}        
      ></MedicoModal>
      )}
    </>
  );
}
export default MedicoView;
